import React, { useEffect } from "react";

import { Tab } from "react-bootstrap";

import { myInvoiceApi } from "../../../../utility/api/apiList";

import useFilter from "../../../../hooks/useFilter";

import useAxios from "../../../../hooks/useAxios";

import UserTabsComponent from "../../../../components/private/tabs";
import UserFinancialListPersonalContainer from "./userFinancialListPersonalContainer";
import UserFinancialListCompanyContainer from "./userFinancialListCompanyContainer";

export default function UserFinancialList() {
  const { onChange, filterState } = useFilter();

  const {
    data: financialData,
    error,
    run: runFinancialData,
    isLoading: financialDataIsLoading,
  } = useAxios({
    url: myInvoiceApi,
    params: {
      order_by: "-id",
      education: filterState["tab"] === "company" ? "True" : "False",
      page_size: 10,
      page: filterState["page"] || 1,
    },
  });

  //FIXME: Prevent calling runFinancialData() twice
  useEffect(() => {
    runFinancialData();
  }, [filterState["tab"], filterState["page"]]);

  return (
    <UserTabsComponent
      defaultActiveKey={filterState["tab"]}
      onSelect={(k) => {
        onChange("tab", k);
      }}
    >
      <Tab eventKey="personal" title="سفارش‌های شخصی">
        {(filterState["tab"] === "personal" || !filterState["tab"]) && (
          <UserFinancialListPersonalContainer
            loading={financialDataIsLoading}
            financialData={financialData}
          />
        )}
      </Tab>
      <Tab eventKey="company" title="سفارش‌های سازمانی">
        {filterState["tab"] === "company" && (
          <UserFinancialListCompanyContainer
            loading={financialDataIsLoading}
            financialData={financialData}
          />
        )}
      </Tab>
    </UserTabsComponent>
  );
}
